/* 空评论缺省图 */
export const emptyCommentImg = 'https://3vj-fe.3vjia.com/project/designer-h5/images/default/1.8.0/empty_comment.png';

/* 三维家缺省图 */
export const defaultBgImg = 'https://3vj-fe.3vjia.com/project/designer-h5/images/default/default_bg.png';

/* 默认头像 */
export const defaultAvatar = 'https://3vj-fe.3vjia.com/project/designer-h5/images/default/avatar.png';

/** 用户角色id： 业主 */
export const OWNER_ROLE_ID = '10005245';

/* 支付方式： 微信jsapi支付：WX_PAY，微信H5支付：WX_PAY_H5，支付宝H5支付：ALI_PAY  */
export const WX_PAY = 1;

export const WX_PAY_H5 = 2;

export const ALI_PAY = 3;

/** 微信网页授权中转页 */
export const AUTH_URL = `https://passport.3vjia.com/wx/auth?returnUrl=${encodeURIComponent(encodeURI(window.location.href))}&appType=4`;
